import { useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { fetchInternationalPrefixes } from "../api/internationalPrefixesService";
import { createStripesSource } from "../utils/createStripesSource";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var useInternationalPrefixData = function (filters, pageSize) {
    var _a;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = useState(0), totalRecords = _c[0], setTotalRecords = _c[1];
    var _d = useQuery(["international-prefixes", filters, pageOffset, pageSize], function () {
        return fetchInternationalPrefixes(ky, {
            agencies: filters.agencies,
            offset: pageOffset,
            limit: pageSize,
        });
    }, {
        keepPreviousData: true,
        onSuccess: function (data) {
            var _a;
            setTotalRecords((_a = data.totalRecords) !== null && _a !== void 0 ? _a : 0);
        },
    }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError, refetch = _d.refetch;
    var internationalPrefixesData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var source = createStripesSource({
        ky: ky,
        data: internationalPrefixesData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        isLoaded: !isLoading,
        fetchMore: function () {
            setPageOffset(pageOffset + pageSize);
        },
    });
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var resetPageOffset = function () { return setPageOffset(0); };
    return {
        internationalPrefixesData: internationalPrefixesData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
        fetchMoreData: fetchMoreData,
        pageOffset: pageOffset,
        resetPageOffset: resetPageOffset,
        source: source,
        pageSize: pageSize,
    };
};
